import Constants from '../containers/UserManagement/contants'
import { instance } from '../lib/api'
import CommonConstants from '../utils/CommonConstants'

export const CHILD_USER_LIST = 'CHILD_USER_LIST'
export const CHILD_USER_LIST_RESET = 'CHILD_USER_LIST_RESET'
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS'
export const USER_UPDATE_FAIL = 'USER_UPDATE_FAIL'
export const USER_UPDATE_RESET = 'USER_UPDATE_RESET'
export const SHOW_LOADER = 'SHOW_LOADER'
export const HIDE_LOADER = 'HIDE_LOADER'
import { SHOW_SNACKBAR_TOASTR } from './loading'

const API_FAIL = 'API_FAIL'

const processRoles = roles => {
  const {
    additionalAdminRoles,
    additionalLkpAdminRoles,
    additionalRoleValueMapping
  } = Constants
  let filteredRoles = []
  roles.forEach(role => {
    if (
      additionalAdminRoles.includes(role) ||
      additionalLkpAdminRoles.includes(role)
    ) {
      filteredRoles = filteredRoles.concat(additionalRoleValueMapping[role])
    } else {
      filteredRoles.push(role)
    }
  })
  return [...new Set(filteredRoles)]
}

const getUserChildrenListUrl = (
  // for the time being userId is hardcode to 100116958 as it the top heirarchy
  // as techrcm@housing.com  is master user
  userId,
  apiVersion = 'v1',
  { start = 0, rows = 10, agentId, email } = {}
) => {
  let filter
  let optionalUrlParams

  if (agentId) {
    filter = { equal: { agentIds: [agentId] } }
  } else if (email) {
    filter = { equal: { emailIds: [email] } }
  }
  const filters = filter ? `,"filters":{"and":[${JSON.stringify(filter)}]}` : ''

  if (apiVersion === 'v1') {
    optionalUrlParams = ''
  } else if (apiVersion === 'v2') {
    optionalUrlParams = `,"paging":{"start":${start},"rows":${rows}}${filters}`
  }

  const urlParamsStatus = 'status=active'
  const urlParamFromCache = 'fromCache=false'
  const urlParamUserId = 'userId=100116958'
  const urlParamSelectorFields = [
    'userId',
    'designationId',
    'priority',
    'userRoles',
    'role',
    'roleId',
    'company',
    'email',
    'name',
    'parentId',
    'contactNumbers',
    'contactNumber',
    'user',
    'id',
    'status',
    'employeeCode',
    'joiningDate',
    'departmentId'
  ]
  const urlParamSelector = `selector={"fields":${JSON.stringify(
    urlParamSelectorFields
  )}${optionalUrlParams}}`

  const urlParams = [
    urlParamsStatus,
    urlParamFromCache,
    urlParamUserId,
    urlParamSelector
  ]

  return `/madrox/app/${apiVersion}/entity/child-list?${urlParams.join('&')}`
}

const hasOnlyRcmUserRole = roles => {
  return roles && roles.length === 1 && roles[0] === 'RCM_USER'
}

export const getUserChildrenList = (
  userId,
  isMakaan,
  apiVersion = 'v1',
  urlQueryParams
) => {
  const url = getUserChildrenListUrl(userId, apiVersion, urlQueryParams)
  return dispatch => {
    dispatch({
      type: SHOW_LOADER
    })
    dispatch({
      type: USER_UPDATE_RESET
    })
    instance({
      url,
      method: 'get'
    })
      .then(response => {
        const { data = [] } = response.data || {}
        const childUserList = apiVersion === 'v1' ? data : data.results
        const rcmChildUserList = []
        const childUserListTotalCount =
          apiVersion === 'v1' ? (data || []).length : data.results.length
        const managerList = []
        const userIdNameChildMapping = {}
        const userIdChildMap = {}
        const userEmpCodeMap = {}
        if (childUserList && childUserList.length) {
          childUserList.forEach(user => {
            const { employeeCode = '' } = user
            userIdNameChildMapping[user.userId] = user.name
            userIdChildMap[user.userId] = user
            if (employeeCode) {
              userEmpCodeMap[employeeCode] = user
            }
            var userRoles =
              user.user && user.user.userRoles ? user.user.userRoles : []
            const tempRole = []
            userRoles.forEach(roleValue => {
              // eslint-disable-next-line no-restricted-syntax
              for (const key in CommonConstants.rolesUserManagement) {
                if (
                  CommonConstants.rolesUserManagement[key] ===
                  roleValue.role.name
                ) {
                  tempRole.push(roleValue.role.name)
                }
              }
            })
            if (tempRole.length) {
              user.roles = tempRole
              if (!hasOnlyRcmUserRole(tempRole)) {
                rcmChildUserList.push(user)
              }
            }
            let managerAdded = false
            if (userRoles && userRoles.length) {
              userRoles.forEach(role => {
                if (role.role && role.role.name && !managerAdded) {
                  managerList.push(user)
                  managerAdded = true
                }
              })
            }
          })
        }
        dispatch({
          type: CHILD_USER_LIST,
          childUserList: rcmChildUserList,
          childUserListTotalCount,
          managerList,
          userIdNameChildMapping,
          userEmpCodeMap,
          userIdChildMap
        })
        dispatch({
          type: HIDE_LOADER
        })
        return rcmChildUserList
      })
      .catch(() => {
        dispatch({
          type: API_FAIL
        })
        dispatch({
          type: HIDE_LOADER
        })
      })
  }
}

const updateUserDetails = (user, userInfo, dispatch) => {
  if (user.id) {
    const url = `/madrox/data/v1/entity/company/company-users/${user.id}`
    const dataObj = {}
    dataObj.email = user.email
    dataObj.employeeCode = user.employeeCode
    dataObj.name = user.name
    dataObj.userRoles = processRoles(user.role)
    dataObj.department = 'Others'
    dataObj.parentId = user.manager
    dispatch({
      type: SHOW_LOADER
    })
    return instance({
      url,
      method: 'put',
      data: dataObj
    }).then(
      () => {
        dispatch({
          type: USER_UPDATE_SUCCESS
        })
        dispatch({
          type: HIDE_LOADER
        })
        return user
      },
      err => {
        dispatch({
          type: USER_UPDATE_FAIL,
          errMsg: Constants.getErrorMessage(err)
        })
        dispatch({
          type: HIDE_LOADER
        })
        return false
      }
    )
  }
  return false
}

const createUserDetails = (
  user,
  userInfo,
  dispatch,
  sendUserDetailsIfDuplicate = true
) => {
  dispatch({
    type: SHOW_LOADER
  })
  const url = `/madrox/data/v1/entity/company/company-users?sendUserDetailsIfDuplicate=${sendUserDetailsIfDuplicate}`
  const dataObj = {}
  dataObj.status = 'Active'
  dataObj.email = user.email
  dataObj.employeeCode = user.employeeCode
  dataObj.branch = 'Gurgaon'
  dataObj.name = user.name
  dataObj.companyId = 499
  dataObj.parentId = user.manager
  dataObj.userRoles = processRoles(user.role)
  dataObj.user = { contactNumbers: [], domainId: 2, countryId: 1 }
  dataObj.department = 'Others'
  return instance({
    url,
    method: 'post',
    data: dataObj
  }).then(
    response => {
      dispatch({
        type: USER_UPDATE_SUCCESS,
        msg: 'User created successfully'
      })
      dispatch({
        type: HIDE_LOADER
      })
      return response.data.data
    },
    err => {
      dispatch({
        type: USER_UPDATE_FAIL,
        errMsg: Constants.getErrorMessage(err)
      })
      dispatch({
        type: HIDE_LOADER
      })
      return err.response || {}
    }
  )
}
export const submitAgentDetail = ({
  user,
  userInfo,
  sendUserDetailsIfDuplicate = true
}) => {
  return dispatch => {
    return (user.id ? updateUserDetails : createUserDetails)(
      user,
      userInfo,
      dispatch,
      sendUserDetailsIfDuplicate
    ).then(result => {
      if (result && result.status === 409) {
        return result
      }
      const { userId } = result || {}
      const { id } = userInfo
      if (userId) {
        dispatch(getUserChildrenList(id))
      }
      return result
    })
  }
}
export const deleteUserRoles = (id, roles) => {
  return dispatch => {
    const url = `madrox/data/v1/entity/user/role`
    const dataObj = {}
    dataObj.id = id
    dataObj.roles = roles
    dispatch({
      type: SHOW_LOADER
    })
    return instance({
      url,
      method: 'delete',
      data: dataObj
    })
      .then(response => {
        dispatch({
          type: SHOW_SNACKBAR_TOASTR,
          message: 'Roles Deleted Successfully'
        })
        dispatch({
          type: HIDE_LOADER
        })
      })
      .catch(err => {
        dispatch({
          type: API_FAIL,
          errMsg: Constants.getErrorMessage(err)
        })
      })
  }
}
export const markUserInactive = (id, userId) => {
  const url = `/madrox/data/v1/entity/company/company-users/${id}`
  const dataObj = {}
  dataObj.id = id
  dataObj.status = 'Inactive'
  return dispatch => {
    dispatch({
      type: SHOW_LOADER
    })
    return instance({
      url,
      method: 'put',
      data: dataObj
    })
      .then(() => {
        dispatch({
          type: USER_UPDATE_SUCCESS
        })
        dispatch(getUserChildrenList(userId))
        dispatch({
          type: HIDE_LOADER
        })
      })
      .catch(err => {
        dispatch({
          type: USER_UPDATE_FAIL,
          errMsg: Constants.getErrorMessage(err)
        })
        dispatch({
          type: HIDE_LOADER
        })
      })
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/userManagement.js
 **/